export default __webpack_public_path__ + "static/media/005.66dc8c96.jpg";